import { object, string, number } from "yup";

export const SubscriptionCreateSchema = object({
    plan_type_id: number().required(),
    payment_gateway: string(),
    payment_gateway_plan_id: string(),
});

export const SubscriptionUpdateSchema = object({
    plan_type_id: number().required(),
    payment_gateway: string(),
    payment_gateway_plan_id: string(),
    payment_gateway_sub_id: string(),
});

export const SubscriptionCheckoutCallbackSchema = object({
    state: string().required(),
    subscription_id: string().required(),
});
